import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKlarna = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Klarna",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			clipPath: "url(#clip0_13_5710_klarna_dark)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M33.8541 5.00903H14.1477C12.8542 5.00903 11.8057 6.03068 11.8057 7.29094V15.9295C11.8057 17.1898 12.8542 18.2114 14.1477 18.2114H33.8541C35.1475 18.2114 36.1961 17.1898 36.1961 15.9295V7.29094C36.1961 6.03068 35.1475 5.00903 33.8541 5.00903Z",
					fill: "#FFB3C7"
				}), /* @__PURE__ */ _jsx("g", {
					id: "Group_2",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M33.913 12.7581C33.5939 12.7581 33.3352 13.0124 33.3352 13.3261C33.3352 13.6398 33.5939 13.8942 33.913 13.8942C34.2321 13.8942 34.4908 13.6399 34.4908 13.3261C34.4908 13.0124 34.2321 12.7581 33.913 12.7581ZM32.012 12.3189C32.012 11.8893 31.6385 11.5412 31.1779 11.5412C30.7172 11.5412 30.3437 11.8894 30.3437 12.3189C30.3437 12.7484 30.7172 13.0967 31.1779 13.0967C31.6386 13.0967 32.012 12.7484 32.012 12.3189ZM32.0151 10.8074H32.9356V13.8303H32.0151V13.6371C31.755 13.8115 31.4411 13.914 31.1025 13.914C30.2065 13.914 29.4801 13.1998 29.4801 12.3189C29.4801 11.4379 30.2065 10.7238 31.1025 10.7238C31.4411 10.7238 31.755 10.8263 32.0151 11.0007V10.8074ZM24.6481 11.2011V10.8074H23.7056V13.8303H24.6502V12.4189C24.6502 11.9428 25.1751 11.6868 25.5394 11.6868C25.5431 11.6868 25.5466 11.6872 25.5503 11.6872V10.8076C25.1765 10.8076 24.8326 10.965 24.6481 11.2011ZM22.3003 12.3189C22.3003 11.8893 21.9268 11.5412 21.4662 11.5412C21.0055 11.5412 20.632 11.8894 20.632 12.3189C20.632 12.7484 21.0055 13.0967 21.4662 13.0967C21.9268 13.0967 22.3003 12.7484 22.3003 12.3189ZM22.3033 10.8074H23.2239V13.8303H22.3033V13.6371C22.0433 13.8115 21.7294 13.914 21.3908 13.914C20.4948 13.914 19.7684 13.1998 19.7684 12.3189C19.7684 11.4379 20.4948 10.7238 21.3908 10.7238C21.7294 10.7238 22.0433 10.8263 22.3033 11.0007V10.8074ZM27.8443 10.7261C27.4766 10.7261 27.1285 10.8383 26.8958 11.148V10.8076H25.9792V13.8303H26.9071V12.2418C26.9071 11.7821 27.2206 11.557 27.5982 11.557C28.0028 11.557 28.2354 11.7946 28.2354 12.2355V13.8303H29.1548V11.908C29.1548 11.2045 28.5859 10.7261 27.8443 10.7261ZM18.4274 13.8303H19.391V9.46028H18.4274V13.8303ZM14.1948 13.8315H15.2151V9.45948H14.1948V13.8315ZM17.7634 9.45948C17.7634 10.406 17.3882 11.2865 16.7197 11.941L18.13 13.8317H16.8699L15.3372 11.7769L15.7327 11.4856C16.3887 11.0025 16.765 10.264 16.765 9.45947L17.7634 9.45948Z",
						fill: "#0A0B09"
					})
				})]
			})
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_klarna_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 13,
			fill: "white",
			transform: "translate(12 5)"
		})
	}) })]
});
export default SvgKlarna;
